import { Button, Dialog } from "@luce/ui";

import { useChangePhoneNumberContext } from "../change-phone-number-context";

export function ChangePhoneNumberSuccessModal() {
  const { step, exit } = useChangePhoneNumberContext();

  const handleOpenChange = (next: boolean) => {
    if (!next) exit();
  };

  return (
    <Dialog.Root open={step === "success"} onOpenChange={handleOpenChange} size="sm">
      <Dialog.Header>
        <Dialog.Title>Your phone number has been successfully updated.</Dialog.Title>
        <Dialog.Description>
          You will use this new number to log in to your account
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.Footer layout="stacked">
        <Button size="lg" fullWidth label="OK" onClick={exit} />
      </Dialog.Footer>
    </Dialog.Root>
  );
}
